// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAzKYdJ-w3YlLjGCwwvgFv63BWukXX_Pbk",
  authDomain: "solar-spanish.firebaseapp.com",
  projectId: "solar-spanish",
  storageBucket: "solar-spanish.appspot.com",
  messagingSenderId: "327835805649",
  appId: "1:327835805649:web:dca4a0cea7c3be5a76a2f0",
  measurementId: "G-HLB61K7SKT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const analytics = getAnalytics(app);
export const database = getFirestore(app);
export const storage = getStorage(app);